export default __webpack_public_path__ + "static/media/FICTLF.67b644a1.png";